var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-container',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"report-modals",fn:function(){return [_c('creatives-discrepancy-modal')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }